import { ProfileSection } from '../containers/profile-section';

export const ServiceByIdSkeleton = () => {
  return (
    <>
      {/* Image Carousel Skeleton */}
      <div className="h-64 bg-gray-200 animate-pulse rounded-md mb-4"></div>

      {/* Verified Card and Title Skeleton */}
      <div className="pt-4">
        <div className="h-8 bg-gray-200 animate-pulse rounded-md w-32 mb-2"></div>
        <div className="h-8 bg-gray-200 animate-pulse rounded-md w-3/4 mb-4"></div>
      </div>

      {/* Tabs Skeleton */}
      <div className="pt-6 pb-2">
        <div className="flex gap-2 overflow-x-auto">
          {[1, 2, 3, 4].map(tab => (
            <div key={tab} className="h-10 bg-gray-200 animate-pulse rounded-md w-24"></div>
          ))}
        </div>
      </div>

      {/* Services Section Skeleton */}
      <ProfileSection className="w-full max-w-none mt-2 mb-4">
        <div className="h-7 bg-gray-200 animate-pulse rounded-md w-32 mb-4"></div>
        <div className="flex flex-wrap gap-2 mb-4">
          {Array(8).fill(0).map((_, index) => (
            <div key={index} className="h-8 bg-gray-200 animate-pulse rounded-md w-24"></div>
          ))}
        </div>
        <div className="h-8 bg-gray-200 animate-pulse rounded-md w-24"></div>
      </ProfileSection>

      {/* Contact and Work Hours Skeleton */}
      <div className="flex flex-col md:flex-row w-full gap-4">
        <ProfileSection className="flex flex-col w-full md:w-1/2">
          <div className="h-6 bg-gray-200 animate-pulse rounded-md w-32 mb-3"></div>
          <div className="h-16 bg-gray-200 animate-pulse rounded-md w-full mb-2"></div>
          <div className="h-16 bg-gray-200 animate-pulse rounded-md w-full"></div>
        </ProfileSection>

        <ProfileSection className="flex flex-col w-full md:w-1/2">
          <div className="h-6 bg-gray-200 animate-pulse rounded-md w-32 mb-3"></div>
          <div className="h-16 bg-gray-200 animate-pulse rounded-md w-full mb-2"></div>
          <div className="h-16 bg-gray-200 animate-pulse rounded-md w-full"></div>
        </ProfileSection>
      </div>

      {/* Map Skeleton */}
      <ProfileSection className="w-full max-w-none mt-4 mb-4">
        <div className="h-7 bg-gray-200 animate-pulse rounded-md w-32 mb-2"></div>
        <div className="h-5 bg-gray-200 animate-pulse rounded-md w-56 mb-3"></div>
        <div className="h-48 bg-gray-200 animate-pulse rounded-md w-full"></div>
      </ProfileSection>

      {/* Facilities Skeleton */}
      <ProfileSection className="w-full max-w-none mt-4 mb-4">
        <div className="h-7 bg-gray-200 animate-pulse rounded-md w-32 mb-3"></div>
        <div className="flex flex-wrap gap-2 mb-4">
          {Array(6).fill(0).map((_, index) => (
            <div key={index} className="h-8 bg-gray-200 animate-pulse rounded-md w-24"></div>
          ))}
        </div>
      </ProfileSection>

      {/* Reviews Skeleton */}
      <ProfileSection className="w-full max-w-none mt-4 mb-4">
        <div className="h-7 bg-gray-200 animate-pulse rounded-md w-32 mb-3"></div>
        <div className="h-32 bg-gray-200 animate-pulse rounded-md w-full mb-3"></div>
        <div className="h-32 bg-gray-200 animate-pulse rounded-md w-full mb-3"></div>
        <div className="h-8 bg-gray-200 animate-pulse rounded-md w-24 mt-2"></div>
      </ProfileSection>
    </>
  );
};